import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { LightPartnerOffering, Template } from "../../data/partner_offering";
import { PartnerConfig } from "../../offering/partner_config";
import { OfferingDetailsDailyAccessV2 } from "../templates/template_offering_details_daily_access";
import { OfferingDetailsDailyOffice } from "../templates/template_offering_details_daily_office";
import {
  TemplateOfferingDetailsMeetingRoom,
  TemplateOfferingDetailsMeetingRoomParams,
} from "../templates/template_offering_details_meeting_room";
import { TemplateOfferingListingGallery } from "../templates/template_offering_listing_gallery";
import { dictionaryHE as dictionaryHEV2 } from "../../locale/he_v2";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { OfferingDetailsMembershipV2 } from "../templates/template_offering_details_membership_v2";
import { TemplateOfferingDetailsEvent } from "../templates/template_offering_details_event";

export function OfferingDetails(props: {
  partnerOffering: LightPartnerOffering;
}) {
  const { onAddToDictionary } = useI18n();
  const { partnerOffering } = props;
  const partnerSlug = partnerOffering.partner.partnerSlug;
  const [partner, setPartner] = useState<any>();
  import(
    `../../offering/${partnerSlug}/${partnerSlug}_partner_config.tsx`
  ).then((partner) => {
    setPartner(partner);
  });

  useEffect(() => {
    onAddToDictionary({ he: dictionaryHEV2, "he-IL": dictionaryHEV2 });
  }, [onAddToDictionary]);

  if (!partner) {
    return null;
  }

  const DefaultTheme = lazyWithRetry(
    () => import("../components/default_theme")
  );
  const PartnerTheme = lazyWithRetry(
    () => import(`../../offering/${partnerSlug}/${partnerSlug}_theme.tsx`)
  );
  const Analytics = lazyWithRetry(
    () => import(`../../offering/${partnerSlug}/${partnerSlug}_analytics.tsx`)
  );

  return (
    <div
      className="offering-details__container"
      style={{ backgroundColor: "#fafafa", paddingBottom: "40px" }}
    >
      <DefaultTheme />
      <PartnerTheme />
      <Analytics />
      {
        <OfferingDetailsTemplate
          partnerOffering={partnerOffering}
          partnerConfig={partner.partnerConfig}
        />
      }
    </div>
  );
}

function OfferingDetailsTemplate(props: {
  partnerOffering: LightPartnerOffering;
  partnerConfig: PartnerConfig;
}) {
  const { partnerOffering, partnerConfig } = props;
  const pageParams = useParams<TemplateOfferingDetailsMeetingRoomParams>();

  switch (props.partnerOffering.template) {
    case Template.DailyAccessV2:
      return <OfferingDetailsDailyAccessV2 partnerConfig={partnerConfig} />;
    case Template.DailyOffice:
      return <OfferingDetailsDailyOffice partnerConfig={partnerConfig} />;
    case Template.MeetingRoomV2:
      if (pageParams.spaceID) {
        return (
          <TemplateOfferingDetailsMeetingRoom partnerConfig={partnerConfig} />
        );
      }
      return (
        <TemplateOfferingListingGallery
          partnerConfig={partnerConfig}
          partnerId={partnerOffering.partner.id}
        />
      );
    case Template.EventSpace:
      if (pageParams.spaceID) {
        return <TemplateOfferingDetailsEvent partnerConfig={partnerConfig} />;
      }
      return (
        <TemplateOfferingListingGallery
          partnerConfig={partnerConfig}
          partnerId={partnerOffering.partner.id}
        />
      );
    case Template.Membership:
      return <OfferingDetailsMembershipV2 partnerConfig={partnerConfig} />;

    case Template.AddOnV2:
      return (
        <OfferingDetailsDailyAccessV2
          showCheckoutPrice={false}
          showSinglePass={false}
          partnerConfig={partnerConfig}
        />
      );
    default:
      throw new Error(
        "This offering template is not supported " + partnerOffering.template
      );
  }
}
